@use 'styles/shared.module';
@use 'styles/mixins';

.Wrap {
  position: relative;

  overflow: visible !important;
}

.Btn {
  @include mixins.flex-centered;

  background-color: transparent;

  &_WithRightMargin {
    margin-right: 1.6rem;
  }
}

.Menu {
  @include shared.Menu;
  top: 3.5rem;
  right: 0;
}

.Tooltip {
  padding: 0.8rem 1rem;
  width: unset;
  border-radius: 5px;
  box-shadow: 0 2px 8px #21252926;
  background-color: #fff;
}
